<template>
  <div class="row mt-3 mx-0" v-if="settings.display_profile">
    <div class="col-12">
      <div class="profile">
        <div class="image">
          <img :src="settings.profile_image" class="img-fluid" alt="" />
        </div>
        <div class="text">
          <p class="title" v-bind:style="{ color: settings.profile_text_color }">
            {{ settings.user_name }}
          </p>
          <p class="sub-title" v-bind:style="{ color: settings.profile_text_color }">
            {{ settings.user_description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserProfile",
  props: ["setting"],
  data() {
    return {
      settings: null,
    };
  },
  created() {
    if (!this.setting) {
      this.settings = this.$session.get("response").settings;
    } else {
      this.settings = this.setting;
    }
  },
  mounted() {
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            this.settings = this.$session.get("response").settings;
          } else if (event.data.option) {
            this.settings = this.$session.get("response").settings;
          }
        }
      },
      false
    );
  },
};
</script>
<style scoped lang="scss">
.profile {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 5px;
  padding: 10px 16px;
  .image {
    width: 50px;
    height: 50px;
    min-width: 50px;
    max-width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 50%;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2));
    margin-right: 17px;
  }
  .text {
    text-align: left;
    width: calc(100% - 67px);
    .title {
      margin: 0;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 22px;
      color: #313c4e;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
    }
    .sub-title {
      margin: 0;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;
      color: #2b3648;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
    }
  }
}
</style>
